/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_Banner_Description_PersonalInputs */



/**
* | output |
* | --- |
* | "You have read-only access to this project. Sending a message will create your own copy." |
*
* @param {Chat_Shared_Banner_Description_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_shared_banner_description_personal = /** @type {((inputs?: Chat_Shared_Banner_Description_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_Banner_Description_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben nur Lesezugriff auf dieses Projekt. Beim Senden einer Nachricht wird eine eigene Kopie erstellt.")
	return /** @type {LocalizedString} */ ("You have read-only access to this project. Sending a message will create your own copy.")
});